module.exports = __webpack_public_path__ + "static/media/analitycs.1b7d2d28.svg";